import { useSettingsQuery } from "@/api/queries/admin/SettingsQueries";
import Loading from "@/components/loading/Loading";
import { Navigate, Outlet } from "react-router-dom";

const AppSetupCompleteRoutes = () => {
    const { data: settingsData, isPending: isPendingSettings } = useSettingsQuery();
    if (isPendingSettings)
        return (
            <div className="absolute inset-0 flex items-center justify-center">
                <Loading size="large" />
            </div>
        );
    if (!settingsData?.setup_completed) {
        return <Navigate to="/setup" />;
    }
    return <Outlet />;
};

export default AppSetupCompleteRoutes;
